/**
 * Copyright (c) Microsoft. All rights reserved.
 */

// tslint:disable:no-any
// tslint:disable:export-name
// tslint:disable:function-name

export function toJson(obj: any): string {
    try {
        return JSON.stringify(obj);
    } catch (error) {
        return `Unable to serialize object of type ${typeof obj}`;
    }
}

export function calculateTtlInSec(expirationTsInSec: number | undefined): number {
    const now = Math.round(new Date().getTime() / 1000);

    return expirationTsInSec !== undefined && expirationTsInSec > now
        ? expirationTsInSec - now
        : 0;
}

export function calculateExpireTsInSec(ttlInSec: number): number {
    return Math.round(new Date().getTime() / 1000) + ttlInSec;
}

/***
 * Correlation vector
 */
export class CorrelationVector {
    private base: string;
    private extension: number;

    private constructor(correlationVector?: string) {
        this.base = (correlationVector !== undefined) ? correlationVector : this.createCorrelationVectorBase();
        this.extension = 0;
    }

    public static extend(correlationVector?: string): CorrelationVector {
        return new CorrelationVector(correlationVector);
    }

    public increase() {
        this.extension++;
    }

    public value(): string {
        return `${this.base}.${this.extension}`;
    }

    private createCorrelationVectorBase(): string {
        const length = 21;
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0987654321/+';
        const endChars = 'AQgw';
        let result = '';
        for (let i = 0; i < length; i++) {
            // tslint:disable-next-line:insecure-random
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        // tslint:disable-next-line:insecure-random
        result += endChars.charAt(Math.floor(Math.random() * endChars.length));

        return result;
    }
}

/**
 * Simplify calculation of time intervals
 */
export class Timespan {
    private start: number;

    constructor() {
        this.start = Date.now();
    }

    /**
     * Returns number of milliseconds from start
     */
    public get duration(): number {
        return Date.now() - this.start;
    }

    /**
     * Returns start time
     */
    public get startTime() {
        return this.start;
    }

    /**
     * Reset start of interval to current timestamp
     */
    public reset() {
        this.start = Date.now();
    }
}



// WEBPACK FOOTER //
// ./lib_temp/Common.ts